<app-shop-header [megaMenu]="false"></app-shop-header>
<div class="layoutWrapp">
    <mat-sidenav-container class="main-container" autosize>
        <mat-sidenav #sidenav class="main-sidenav" mode="side" opened="true">
            <button id="layout_manager_1" class="toggleButton" mat-icon-button (click)="isExpanded = !isExpanded">
                <lucide-icon name="Menu" class="lucid-icon-menu"></lucide-icon>
            </button>
            <div class="sideMenu">
                <ul>
                  <li
                    *ngFor="let sideNavItem of sideNavList; index as i"
                    (click)="
                      navigate(sideNavItem.route);
                      setActiveItem(sideNavItem.name, sideNavItem);
                      selectedParent == sideNavItem.name ? (selectedParent = '') : (selectedParent = sideNavItem.name)
                    "
                    [class.activeChild]="isChildActive(sideNavItem.children)"
                    [class.activeItem]="sideNavItem.route === routeUrl"
                  >
                    <ng-container *ngIf="sideNavItem.visible && !sideNavItem.parent">
                      <button
                        id="layout_manager_2"
                        class="toggleButton"
                        mat-icon-button
                        *ngIf="!isExpanded"
                        matTooltip="{{ sideNavItem.name }}"
                        matTooltipPosition="right"
                      >
                        <lucide-icon name="{{ sideNavItem.icon }}" class="lucid-icon-menu"> </lucide-icon>
                      </button>
                      <button id="layout_manager_2" class="toggleButton" mat-icon-button *ngIf="isExpanded">
                        <lucide-icon name="{{ sideNavItem.icon }}" class="lucid-icon-menu"> </lucide-icon>
                      </button>
                      <span class="menuText" *ngIf="isExpanded || isShowing">{{ sideNavItem.name }}</span>
                      <mat-icon class="dropdown-arrow" *ngIf="isExpanded" [class.rotated]="selectedParent == sideNavItem.name"
                        >keyboard_arrow_down</mat-icon
                      >
                    </ng-container>
                    <div *ngIf="sideNavItem.children && selectedParent == sideNavItem.name" (click)="$event.stopPropagation()">
                      <ul *ngIf="isExpanded">
                        <li
                          *ngFor="let child of sideNavItem.children; index as i"
                          (click)="navigate(child.route)"
                          class="childIcon"
                          [class.activeItem]="child.route === routeUrl"
                        >
                          <ng-container *ngIf="child.visible">
                            <button class="toggleButton" mat-icon-button>
                              <mat-icon>{{ child?.icon }}</mat-icon>
                            </button>
                            <span class="menuText" *ngIf="isExpanded || isShowing">{{ child.name }}</span>
                          </ng-container>
                        </li>
                      </ul>
                    </div>
                  </li>
                  <li class="bottomFixed" (click)="downloadGuide()" matTooltip="Download User Manual" matTooltipPosition="right">
                    <span class="menuIco">
                      <lucide-icon name="book-text" class="lucid-icon-menu"></lucide-icon>
                    </span>
                    <span class="menuText" *ngIf="isExpanded || isShowing">Download User Manual</span>
                  </li>
                </ul>
            </div>
        </mat-sidenav>
        <div class="main-sidenav-content" [ngClass]="{ sideOpennav: isExpanded }">
            <router-outlet></router-outlet>
        </div>
    </mat-sidenav-container>
</div>

